import React, { Component } from 'react';
import './../css/master.css';
import './../css/csProgressUpdate.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';
import FailPass from './switch.js'; 

var httpURL = '';
var queryString = require('querystring');
var lstYardage			= [];
var lstProgress			= [];
var lstConstruction		= [];

class CSProgressUpdate extends Component {
  constructor(props){
	super(props);
	this.state={
		flg:true,
		designImagePath : require('./../images/blank.png'),
		loader:'none',
		opacity:1,
		checked1:false,
		checked2:false,
		checked3:false,
		checked4:false,
		checked5:false,
		checked6:false,
		checked7:false,
		checked8:false,
		checked9:false,
		checked10:false,
		checked11:false,
		checked12:false,
		yardage:[],
		progress:[],
		progressStatusId:0,
		reasonId:0,
		width1:'97%',
		width2:'97%',
	}
  }
  
  handleChange2=(e)=>{
	this.setState({
		checked2:e,
	});
  }
  handleChange4=(e)=>{
	this.setState({
		checked4:e,
	});
  }
  handleChange6=(e)=>{
	this.setState({
		checked6:e,
	});
  }
  handleChange8=(e)=>{
	this.setState({
		checked8:e,
	});
  }
  handleChange10=(e)=>{
	this.setState({
		checked10:e,
	});
  }
  handleChange12=(e)=>{
	this.setState({
		checked12:e,
	});
  }
  
  async componentWillUnmount() {
        await localStorage.removeItem('updateProgress');
    }
  
  async componentDidMount(){
	await axiosInstance.get(httpURL+'/a/mst/cons/list',{
		withCredentials: true
	}).then((response)=> {
		  if(response.data.SvcStatus === 'Success'){
			  lstConstruction = response.data.lstConstruction;
			  this.fillConstructionCmb();
		  }
		  else{
			  toast.error(response.data.SvcMsg);
			  if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSRURL;
				return false;
			}
		  }
	  }).catch((error)=> {
		   toast.error("Service failed " + error);
	});

	var detail = await localStorage.getItem('updateProgress');
	var details = JSON.parse(detail);
	
	$('#ipoId').val(details.ipoId);
	$('#ipoNo').val(details.ipoNo);
	$('#bpoId').val(details.bpoId);
	$('#bpoNo').val(details.bpoNo);
	$('#ipoDesignId').val(details.ipoDesignId);
	$('#designId').val(details.designId);
	$('#designNoColor').val(details.designNoColor);
	$('#bpoStyleId').val(details.bpoStyleId);
	$('#styleColor').val(details.style+'-'+details.color);
	$('#quality').val(details.quality);
	$('#length').val(details.length);
	$('#width').val(details.width);
	$('#yarnCount').val(details.yarnCount);
	$('#construction').val(details.construction);
	
	var deskloom = {};
	var ipoDesignId = $('#ipoDesignId').val();
	deskloom = {ipoDesignId};
	
	this.setState({loader:'block', opacity:0.5, designImagePath: details.imageUrl});
	
	axiosInstance.post(httpURL+'/a/ipo/prog/listdeskloom',
	  queryString.stringify({'deskloom':JSON.stringify(deskloom)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			$('#weaverDeskloomDt').val(response.data.lstDeskLoom[0].deskLoomDt);
			if(response.data.lstDeskLoom[0].deskLoomStatusId == 2){
				$('#approve').attr('checked', true);
			}else if(response.data.lstDeskLoom[0].deskLoomStatusId == 3){
				$('#reject').attr('checked', true);
			}else{
				$('#approve').attr('checked', false);
				$('#reject').attr('checked', false);
			}
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});

	this.yardage();
	this.progress();
	this.handleResize();
	window.addEventListener("load", this.handleResize);
	window.addEventListener("resize", this.handleResize);
  }
  
  fillConstructionCmb(){
	$('.constructionCmb').empty();
	$('.constructionCmb').prepend($("<option> </option>").val(0).html('Construction'));
	for(var i=0; i<lstConstruction.length; i++){
		var constructionId = lstConstruction[i].constructionId;
		var construction   = lstConstruction[i].construction;
		$('.constructionCmb').append($("<option> </option>").val(constructionId).html(construction));
	}
  }

  handleResize=()=>{
	var width1 = ($('.tableLayout1').parent().width())-17;
	var width2 = ($('.tableLayout2').parent().width())-17;
	this.setState({width1:width1, width2:width2})
  }
  
  yardage=()=>{
	var ipoDesignId =  $('#ipoDesignId').val();
	var deskloom = {ipoDesignId};  
	this.setState({loader:'display', opacity:0.5});
	axiosInstance.post(httpURL+'/a/ipo/prog/listyardage',
	  queryString.stringify({'yardage':JSON.stringify(deskloom)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			this.setState({
				yardage:response.data.lstYardage,
			})
			lstYardage = this.state.yardage;
			this.setYardageData();
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  progress=()=>{
	var ipoDesignId =  $('#ipoDesignId').val();
	var deskloom = {ipoDesignId};  
	this.setState({loader:'display', opacity:0.5});
	axiosInstance.post(httpURL+'/a/ipo/prog/listprogress',
		queryString.stringify({'progress':JSON.stringify(deskloom)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			this.setState({
				progress:response.data.lstProgress,
			})
			lstProgress = this.state.progress;
			this.setProgressTable();
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  setProgressTable=()=>{
	$('#progressTbody tr').remove();  
	var table = document.getElementById('progressTable');
	var tbody = document.getElementById('progressTbody');

	for(var i=0; i<lstProgress.length; i++){
		var wvrSubmitDt = lstProgress[i].progressSubmitDt;
		var progress1 	= lstProgress[i].progress1 == '00-00-0000' ? '' : lstProgress[i].progress1;
		var progress2	= lstProgress[i].progress2 == '00-00-0000' ? '' : lstProgress[i].progress2;
		var progress3	= lstProgress[i].progress3 == '00-00-0000' ? '' : lstProgress[i].progress3;
		var progressId	= lstProgress[i].progressId;
		var reasonId 	= lstProgress[i].reasonId;
		var actionDt 	= lstProgress[i].progressActionDt;
		var progressStatusId = lstProgress[i].progressStatusId
		if(i == 0){
			this.setState({
				progressStatusId:progressStatusId,
				reasonId:reasonId,
			})
		}
		var row = document.createElement('tr');
		row.id = progressId;
		this.addTD(row, wvrSubmitDt, 'text-center');
		this.addTD(row, progress1, 'text-center');
		this.addTD(row, progress2, 'text-center');
		this.addTD(row, progress3, 'text-center');
		this.addTDCmb(row, progressStatusId, '');
		this.addTDCmb1(row, reasonId, '')
		this.addTD(row, actionDt, 'text-center');

		tbody.append(row);
	}
	table.append(tbody);
  }
  addTD(row, val, classname){
	var cell = document.createElement('td');
	cell.className = classname;
	var text = document.createTextNode(val);
	cell.append(text);
	row.append(cell);
  }

  addTDCmb(row, val, classname){
	var cell = document.createElement('td');
	cell.className = classname;
	var select = document.createElement('select');
	select.className = 'form-control';
	select.addEventListener('change', this.checkProgressStatus);
	var option1 = document.createElement('option');
	var option2 = document.createElement('option');
	var option3 = document.createElement('option');
	option1.value = 1;
	option2.value = 2;
	option3.value = 3;
	option1.innerHTML = 'Pending';
	option2.innerHTML = 'Approve';
	option3.innerHTML = 'Reject';
	select.append(option1);
	select.append(option2);
	select.append(option3);
	cell.append(select);
	select.value = val;
	row.append(cell);
  }

  addTDCmb1(row, val, classname){
	var cell = document.createElement('td');
	cell.className = classname;
	var select = document.createElement('select');
	select.className = 'form-control';
	select.addEventListener('change', this.checkReasonStatus);
	var option1 = document.createElement('option');
	var option2 = document.createElement('option');
	var option3 = document.createElement('option');
	var option4 = document.createElement('option');
	var option5 = document.createElement('option');
	var option6 = document.createElement('option');
	var option7 = document.createElement('option');
	var option8 = document.createElement('option');
	var option9 = document.createElement('option');
	var option10 = document.createElement('option');

	option1.value = 0;
	option2.value = 1;
	option3.value = 2;
	option4.value = 3;
	option5.value = 4;
	option6.value = 5;
	option7.value = 6;
	option8.value = 7;
	option9.value = 8;
	option10.value = 9;
	option1.innerHTML = 'Status';
	option2.innerHTML = 'Approval delayed';
	option3.innerHTML = 'Change in Order Quantity';
	option4.innerHTML = 'Payment delay to weaver';
	option5.innerHTML = 'Color cutting delay';
	option6.innerHTML = 'Wrong planning';
	option7.innerHTML = 'Non availability of yarn';
	option8.innerHTML = 'Wrong color matching';
	option9.innerHTML = 'Wants to Hold';
	option10.innerHTML = 'Payment delay to CS';

	select.append(option1);
	select.append(option2);
	select.append(option3);
	select.append(option4);
	select.append(option5);
	select.append(option6);
	select.append(option7);
	select.append(option8);
	select.append(option9);
	select.append(option10);
	cell.append(select);
	select.value = val;
	row.append(cell);
  }

  saveDeskloom=()=>{
	var deskloom = {};
	var ipoDesignId = $('#ipoDesignId').val();
	var deskLoomStatus = $("input[name='approveReject']:checked").val();
	var deskLoomDate = $("#weaverDeskloomDt").val();
	if(deskLoomDate == ''){
		toast.warning('Weaver has not completed the deskloom yet');
		return false;
	}

	if(deskLoomStatus == undefined){
		toast.warning('Please select status');
		return false;
	}
	deskloom = {ipoDesignId, deskLoomStatus};
	this.setState({loader:'block', opacity:0.5});
	
	axiosInstance.post(httpURL+'/a/ipo/prog/savedeskloom',
	  queryString.stringify({'deskloom':JSON.stringify(deskloom)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  setYardageData=()=>{
	  $('#yardageDate').val(lstYardage[0].yardageDt);
	  $('#QCDone').prop('checked', lstYardage[0].qcByWeaver);
	  $('#internalQC').val(lstYardage[0].iqcYardageStatusId);
	  $('#externalQC').val(lstYardage[0].eqcYardageStatusId);
	  $('#reportNo').val(lstYardage[0].reportNo);
	  if(lstYardage[0].eqcYardageStatusId == 4){
		  $('#reportDiv').hide();
		  $('#externalQC').attr('disabled', true);
	  }else{
		 $('#reportDiv').show();
		 $('#externalQC').attr('disabled', false);
	  }
	  this.setState({
		checked1:lstYardage[0].wvrCfrDry == 1 ? true : false,
		checked2:lstYardage[0].cfrDry == 1 ? true : false,
		checked3:lstYardage[0].wvrCfrWet == 1 ? true : false,
		checked4:lstYardage[0].cfrWet == 1 ? true : false,
		checked5:lstYardage[0].wvrCfw == 1 ? true : false,
		checked6:lstYardage[0].cfw == 1 ? true : false,
		checked7:lstYardage[0].wvrCfwWet == 1 ? true : false,
		checked9:lstYardage[0].wvrStnCotton == 1 ? true : false,
		checked10:lstYardage[0].stnCotton == 1 ? true : false,
		checked11:lstYardage[0].wvrShrinkage == 1 ? true : false,
		checked12:lstYardage[0].shrinkage == 1 ? true : false,
	  }) 
	  $('#wvrWarpShrinkage').val(lstYardage[0].wvrWarpShrinkagePerc);
	  $('#csWarpShrinkage').val(lstYardage[0].warpShrinkagePerc);
	  $('#wvrWeftShrinkage').val(lstYardage[0].wvrWeftShrinkagePerc);
	  $('#csWeftShrinkage').val(lstYardage[0].weftShrinkagePerc);
	  $('#wvrConstructions').val(lstYardage[0].wvrConstructionId);
	  $('#csConstructions').val(lstYardage[0].constructionId);
  }

  checkIntStatus=(e)=>{
	var val= $(e.target).find('option:selected').val();
	var oldVal = lstYardage[0].iqcYardageStatusId;
	if((oldVal == 2 || oldVal == 3) && val == 1) {
		toast.warning('You can not change status to PENDING');
		$(e.target).val(oldVal);
	}
  }

  checkExtStatus=(e)=>{
	var val= $(e.target).find('option:selected').val();
	var oldVal = lstYardage[0].eqcYardageStatusId;
	
	if((oldVal == 1 || oldVal == 2 || oldVal == 3) && val == 4) {
		toast.warning('You can not change status to N/A');
		$(e.target).val(oldVal);
		return false;
	}

	if((oldVal == 2 || oldVal == 3) && (val == 1 || val == 4)) {
		toast.warning('You can not change status to PENDING or N/A');
		$(e.target).val(oldVal);
	}
  }

  saveYardage=()=>{
	var yardage = {};
	var ipoDesignId = $('#ipoDesignId').val();
	var iqcYardageStatusId = $('#internalQC').find('option:selected').val();
	var eqcYardageStatusId =   $('#externalQC').find('option:selected').val();
	var reportNo =   $('#reportNo').val();
	var yardageDate = $("#yardageDate").val();
	if(yardageDate == ''){
		toast.warning('Weaver has not completed the yardage yet');
		return false;
	}
	var cfrDry = this.state.checked2 == true ? 1 : 2;
	var cfrWet = this.state.checked4 == true ? 1 : 2;
	var cfw = this.state.checked6 == true ? 1 : 2;
	var stnCotton = this.state.checked10 == true ? 1 : 2;
	var shrinkage = this.state.checked12 == true ? 1 : 2;
	var warpShrinkagePerc = $('#csWarpShrinkage').val();
	var weftShrinkagePerc = $('#csWeftShrinkage').val();
	var constructionId = $('#csConstructions').find('option:selected').val();
	
	yardage = {ipoDesignId, iqcYardageStatusId, eqcYardageStatusId, reportNo, cfrDry, cfrWet, cfw, stnCotton, shrinkage, warpShrinkagePerc, weftShrinkagePerc, constructionId};
	this.setState({loader:'block', opacity:0.5});
	
	axiosInstance.post(httpURL+'/a/ipo/prog/saveyardage',
	  queryString.stringify({'yardage':JSON.stringify(yardage)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  checkProgressStatus=(e)=>{
	var val= $(e.target).find('option:selected').val();
	var oldVal = lstProgress[0].progressStatusId;
	if((oldVal == 2 || oldVal == 3) && val == 1) {
		toast.warning('You can not change status to PENDING');
		$(e.target).val(oldVal);
	}else{
		this.setState({
			progressStatusId:val,
		})
	}
  }

  checkReasonStatus=(e)=>{
	var val= $(e.target).find('option:selected').val();
	this.setState({
		reasonId:val,
	});
  }

  saveProgress=()=>{
	var progress = {};
	var ipoDesignId = $('#ipoDesignId').val();
	var progressId = $('#progressTbody tr').eq(0).attr('id');
	var progressStatusId = this.state.progressStatusId;
	var reasonId = this.state.reasonId;
	
	progress = {ipoDesignId, progressId, progressStatusId, reasonId};
	this.setState({loader:'block', opacity:0.5});
	
	axiosInstance.post(httpURL+'/a/ipo/prog/saveprogress',
	  queryString.stringify({'progress':JSON.stringify(progress)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
			lstProgress[0].progressStatusId = progressStatusId;
			lstProgress[0].reasonId = reasonId;
			lstProgress[0].progressActionDt = response.data.progressActionDt;
			this.setProgressTable();
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.CSURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  render() {
	httpURL = window.httpURL;  
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader, zIndex:9999}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div>
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid" style={{paddingTop:10}}>
					<div className="col-sm-12 col-centered">
						<div className="row">
							<div className="col-sm-10" style={{paddingLeft:0}}>
								<div id="deskloomDiv" className="styleBackground">
									<form className="form-inline">
										<div className="form-group">
											<label style={{width:100}} htmlFor="ipoNo">IPO NO:</label>
											<input style={{display:'none'}} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
											<input style={{display:'none'}} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
											<input style={{marginLeft:2}} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="bpoNo">BPO NO:</label>
											<input style={{display:'none'}} placeholder="BPO Id" type="text" className="form-control" id="bpoId" />
											<input style={{marginLeft:2}} readOnly placeholder="BPO Number" type="text" className="form-control" id="bpoNo" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="designNoColor">Design Color:</label>
											<input style={{display:'none'}} placeholder="Design Id" type="text" className="form-control" id="designId" />
											<input style={{marginLeft:2}} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
										</div>
									</form>
									<form className="form-inline" style={{marginTop:5}}>
										<div className="form-group">
											<label style={{width:100}} htmlFor="quality">Quality:</label>
											<input style={{marginLeft:2}} readOnly placeholder="Quality" type="text" className="form-control" id="quality" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="length">Length:</label>
											<input style={{marginLeft:2}} readOnly placeholder="Length" type="text" className="form-control text-right" id="length" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="width">Width:</label>
											<input style={{marginLeft:2}} readOnly placeholder="Width" type="text" className="form-control" id="width" />
										</div>
									</form>
									<form className="form-inline" style={{marginTop:5}}>	
										<div className="form-group">
											<label style={{width:100}} htmlFor="yarnCount">Yarn Count:</label>
											<input style={{marginLeft:2}} readOnly placeholder="Yarn Count" type="text" className="form-control" id="yarnCount" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="construction">Construction:</label>
											<input style={{marginLeft:2}} readOnly placeholder="Construction" type="text" className="form-control" id="construction" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="styleColor">Style-Color:</label>
											<input style={{display:'none'}} placeholder="Style Id" type="text" className="form-control" id="bpoStyleId" />
											<input style={{marginLeft:2}} readOnly placeholder="Style-Color" type="text" className="form-control" id="styleColor" />
										</div>
									</form>
								</div>
								<div style={{marginTop:5, display:'flex', flexDirection:'row'}} className="styleBackground">
									<h4 style={{fontWeight:'bold', color:'#bb592b', width:130, margin:'7px 3px'}}>Deskloom</h4>
									<form className="form-inline">
										<div className="form-group">
											<label htmlFor="weaverDeskloomDt">Weaver Deskloom Date:</label>
											<input style={{marginLeft:2, width:120}} readOnly placeholder="Deskloom Date" type="text" className="form-control text-center" id="weaverDeskloomDt" />
										</div>
										<div className="radio">
											<label><input type="radio" value="CS_APPROVED" id="approve" name="approveReject" />APPROVE</label>
											<label><input type="radio" value="CS_REJECTED" id="reject" name="approveReject" />REJECT</label>
										</div>
										<button style={{marginLeft:40}} onClick={this.saveDeskloom} type="button"className="btn btn-warning">Save</button> 
									</form>
								</div>
								
							</div>
							<div className="col-sm-2 padding-remove" id="designColorImageDivCSProgress">
								<ReactImageMagnify {...{
									smallImage: {
											alt: 'Design Image',
											src: this.state.designImagePath,
											isFluidWidth: true,
									},
									largeImage: {
											src: this.state.designImagePath,
											width: 600,
											height: 900
									},
									enlargedImageContainerDimensions:{
										width:300,
										height:300,
									},
									enlargedImageContainerStyle:{
										left:-100,
										top:170,
									},
								}} />
							</div>
						</div>
						<div className="row styleBackground" style={{marginTop:5, display:'flex', flexDirection:'row'}}>
							<div style={{borderRight:'2px solid #e4e4e4', width:'40%'}}>
								<div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', paddingRight:10}}>
									<h4 style={{fontWeight:'bold', color:'#bb592b', width:130, margin:'5px 0px'}}>PP Yardage</h4>
									<div>
										<button style={{marginLeft:50}} onClick={this.saveYardage} type="button" className="btn btn-warning">Save</button>
										<span onClick={this.yardage} title="Refresh" style={{fontSize:21,color: '#f04e5c',top:5, paddingLeft:10, cursor:'pointer'}} className="glyphicon glyphicon-refresh"></span>
									</div>
								</div>
								<div style={{paddingRight:10}}>
									<form className="form-inline">
										<div className="form-group">
											<label style={{width:82}} htmlFor="yardageDate">Yard. Date:</label>
											<input style={{marginLeft:2, width:84, height:25}} readOnly placeholder="Yard. Date" type="text" className="form-control text-center" id="yardageDate" />
										</div>
										<div className="form-group pull-right">
											<label style={{marginLeft:10, width:150}} htmlFor="QCDone">QC Done by Weaver:</label>
											<div className="checkbox">
												<input disabled type="checkbox" id="QCDone" />
											</div>
										</div>
									</form>
									<form className="form-inline" style={{marginTop:5, display:'flex', justifyContent:'space-between'}}>
										<div className="form-group">
											<label style={{width:82}} htmlFor="internalQC">Internal QC:</label>
											<select onChange={this.checkIntStatus} style={{marginLeft:2, width:84, height:25}} className="form-control lessHeight" id="internalQC">
												<option value="1">Pending</option>
												<option value="2">Approve</option>
												<option value="3">Reject</option>
											</select>
										</div>
										<div className="form-group">
											<label style={{marginLeft:5}} htmlFor="externalQC">Ext. QC:</label>
											<select onChange={this.checkExtStatus} style={{marginLeft:2, width:84, height:25}} className="form-control lessHeight" id="externalQC">
												<option value="4">N/A</option>
												<option value="1">Pending</option>
												<option value="2">Approve</option>
												<option value="3">Reject</option>
											</select>
										</div>
										<div className="form-group" id="reportDiv">
											<label style={{marginLeft:5}} htmlFor="reportNo">Rep. No:</label>
											<input style={{marginLeft:2, width:90, height:25}} placeholder="Report No." type="text" className="form-control" id="reportNo" />
										</div>
									</form>
									<div style={{marginTop:5}}>
										<table style={{width:'100%'}}>
											<thead>
												<tr>
													<th className="text-center" style={{width:200}}>Process</th>
													<th colSpan={2} style={{width:20}}>Weaver</th>
													<th colSpan={2} style={{width:20}}>Chandra Silk</th>
												</tr>
											</thead>
											<tbody id="yardageTbody">
												<tr>
													<td>Color fastness to rubbing (DRY)</td>
													<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange1} checked={this.state.checked1} id="wvrDryRubbing" /></td>
													<td colSpan={2}><FailPass disabled={false} handleChange={this.handleChange2} checked={this.state.checked2} id="csDryRubbing" /></td>
												</tr>
												<tr>
													<td>Color fastness to rubbing (WET)</td>
													<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange3} checked={this.state.checked3} id="wvrWetRubbing" /></td>
													<td colSpan={2}><FailPass disabled={false} handleChange={this.handleChange4} checked={this.state.checked4} id="csWetRubbing" /></td>
												</tr>
												<tr>
													<td>Color fastness to washing</td>
													<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange5} checked={this.state.checked5} id="wvrDryWashing" /></td>
													<td colSpan={2}><FailPass disabled={false} handleChange={this.handleChange6} checked={this.state.checked6} id="csDryWashing" /></td>
												</tr>
												<tr>
													<td>Staining on cotton</td>
													<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange9} checked={this.state.checked9} id="wvrStaining" /></td>
													<td colSpan={2}><FailPass disabled={false} handleChange={this.handleChange10} checked={this.state.checked10} id="csStaining" /></td>
												</tr>
												<tr>
													<td>Warp Shrinkage</td>
													<td>
														<div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
															<input readOnly className="form-control text-right" type="text" id="wvrWarpShrinkage"/>
															<span style={{fontSize:14}}>%</span>
														</div>
													</td>
													<td rowSpan={2}>
														<FailPass disabled={true} handleChange={this.handleChange11} checked={this.state.checked11} id="wvrWarpShrinkageFP" />
													</td>
													<td>
														<div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
															<input className="form-control text-right" type="text" id="csWarpShrinkage"/>
															<span style={{fontSize:14}}>%</span>
														</div>
													</td>
													<td rowSpan={2}>
														<FailPass disabled={false} handleChange={this.handleChange12} checked={this.state.checked12} id="csWarpShrinkageFP" />
													</td>
												</tr>
												<tr>
													<td>Weft Shrinkage</td>
													<td>
														<div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
															<input readOnly className="form-control text-right" type="text" id="wvrWeftShrinkage"/>
															<span style={{fontSize:14}}>%</span>
														</div>
													</td>
													<td>
														<div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
															<input className="form-control text-right" type="text" id="csWeftShrinkage"/>
															<span style={{fontSize:14}}>%</span>
														</div>
													</td>
												</tr>
												<tr>
													<td>Constructions (Read/Pick)</td>
													<td colSpan={2}><select disabled className="constructionCmb form-control" id="wvrConstructions"></select></td>
													<td colSpan={2}><select className="constructionCmb form-control" id="csConstructions"></select></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div style={{paddingLeft:10, width:'60%'}}>
								<div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', paddingRight:20}}>
									<h4 style={{fontWeight:'bold', color:'#bb592b', width:130, margin:5}}>Progress</h4>
									<div>
										<button onClick={this.saveProgress} type="button"className="btn btn-warning">Save</button>
										<span onClick={this.progress} title="Refresh" style={{fontSize:21,color: '#f04e5c',top:5, paddingLeft:10, cursor:'pointer'}} className="glyphicon glyphicon-refresh"></span>
									</div>
								</div>
								<div style={{marginTop:10}}>
									<table className="tableLayout1" style={{width:this.state.width1}}>
										<thead>
											<tr>
												<th style={{width:130}}>Weaver Submit Date </th>
												<th style={{width:80}}>25%</th>
												<th style={{width:80}}>50%</th>
												<th style={{width:80}}>100%</th>
												<th style={{width:100}}>Status</th>
												<th style={{width:150}}>Reason</th>
												<th style={{width:80}}>Action Date</th>
											</tr>
										</thead>
									</table>
									<div style={{height:280, overflowY:'scroll'}}>
										<table className="tableLayout" id="progressTable">
											<colgroup>
												<col style={{width:130}} />
												<col style={{width:80}} />
												<col style={{width:80}} />
												<col style={{width:80}} />
												<col style={{width:100}} />
												<col style={{width:150}} />
												<col style={{width:80}} />
											</colgroup>
											<tbody id="progressTbody"></tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default CSProgressUpdate;
